import React from 'react';
import ActionButton from '~components/atoms/ActionButton';

import Modal from '~components/atoms/Modal';
import Text from '~components/atoms/Text';
import combinedActions from '~redux/combinedActions';
import { useAppDispatch, useAppSelector } from '~redux/hooks';
import { TupdateTransferStatusReduxParams } from '~types/feat/approval';

import { TransferStatusEnum } from '~utils/enums';
import UtilFunctions from '~utils/functions';
import * as Styles from './_confirmUpdateProjectStatusModal.module.scss';

const ConfirmupdateTransferStatusModal = () => {
    const isOpen = useAppSelector(state => state.approval.modals.confirmupdateTransferStatusModalIsOpen);
    const tempUpdateTransferState = useAppSelector(state => state.approval.tempUpdateTransferState);
    const isLoading = useAppSelector(state => state.approval.loadings.updateTransferStatus);
    const error = useAppSelector(state => state.approval.errors.updateTransferStatus);

    const getStatus = () => {
        switch (tempUpdateTransferState.status) {
            case (TransferStatusEnum.Approved): return 'Approve';
            case (TransferStatusEnum.RejectedDeliver): return 'Reject Delivery';
            case (TransferStatusEnum.RejectedReceive): return 'Reject Receive';
            default: return '';
        }
    };

    const dispatch = useAppDispatch();

    const setIsOpen = (open: boolean) => dispatch(combinedActions.approvalSetConfirmupdateTransferStatusModalIsOpen(open));
    const updateTransferStatus = (data: TupdateTransferStatusReduxParams) => dispatch(combinedActions.approvalupdateTransferStatusAttempt(data));

    const handleSubmitClick = () => {
        updateTransferStatus(tempUpdateTransferState);
    };

    const confirmButtonStyles = UtilFunctions.Styles.concatClassNames([
        (getStatus() === 'Approve' ? Styles['confirm-approve'] : ''),
        (getStatus() === 'Reject Delivery' ? Styles['confirm-reject'] : ''),
        (getStatus() === 'Reject Receive' ? Styles['confirm-reject'] : ''),
    ]);

    const handleOnModalClose = () => {
        if (error) {
            dispatch(combinedActions.approvalResetupdateTransferStatusState());
        }

        setIsOpen(false);
    };

    return (
        <Modal
            isOpen={isOpen}
            onClose={handleOnModalClose}
            title={`Confirm ${getStatus()} Transfer?`}
        >
            <div className={Styles['button-container']}>
                <ActionButton
                    label='Cancel'
                    onClick={handleOnModalClose}
                    className={Styles['cancel-button']}
                />

                <ActionButton
                    label={getStatus()}
                    onClick={handleSubmitClick}
                    isLoading={isLoading}
                    className={confirmButtonStyles}
                    disabled={isLoading}
                />
            </div>

            {error
                && (
                    <Text
                        label={error}
                        isError
                    />
                )
            }
        </Modal>
    );
};

export default ConfirmupdateTransferStatusModal;
